module.exports = __webpack_public_path__ + "3a79b3317653d548466cc1b4f5ab8351.webp";